import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const loadImage = (url) => {
  return new Promise((resolve) => {
    const img = new Image();
    img.crossOrigin = "Anonymous";
    img.src = url;
    img.onload = () => resolve(img);
    img.onerror = () => resolve(null);
  });
};

// Funkce pro stažení českého fontu, aby fungovala diakritika (ěščřžýáíé)
const loadCzechFonts = async (doc) => {
  try {
    const fetchFont = async (url) => {
      const res = await fetch(url);
      const buffer = await res.arrayBuffer();
      let binary = '';
      const bytes = new Uint8Array(buffer);
      for (let i = 0; i < bytes.byteLength; i++) {
        binary += String.fromCharCode(bytes[i]);
      }
      return window.btoa(binary);
    };

    const regularB64 = await fetchFont('https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.2.7/fonts/Roboto/Roboto-Regular.ttf');
    const boldB64 = await fetchFont('https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.2.7/fonts/Roboto/Roboto-Medium.ttf');

    doc.addFileToVFS('Roboto-Regular.ttf', regularB64);
    doc.addFont('Roboto-Regular.ttf', 'Roboto', 'normal');

    doc.addFileToVFS('Roboto-Bold.ttf', boldB64);
    doc.addFont('Roboto-Bold.ttf', 'Roboto', 'bold');

    return true;
  } catch (error) {
    console.error("Nepodařilo se načíst fonty", error);
    return false;
  }
};

export const generateInvoice = async (formData, cart, finalTotal, shippingName, paymentName, orderNumber) => {
  const doc = new jsPDF();
  
  // Aktivace českého fontu
  await loadCzechFonts(doc);

  // Získáme data
  const customerName = formData.get("fullName") || "";
  const address = formData.get("address") || "";
  const city = formData.get("city") || "";
  const zip = formData.get("zip") || "";

  const today = new Date();
  const dueDate = new Date(today);
  dueDate.setDate(dueDate.getDate() + 14);

  const formatDate = (date) => date.toLocaleDateString("cs-CZ");
  
  const invoiceNumber = orderNumber ? orderNumber.toString() : "0000"; 

  // --- LOGO ---
  const logoImg = await loadImage("/images/logo.png");
  if (logoImg) {
    doc.addImage(logoImg, "PNG", 14, 10, 40, (40 * logoImg.height) / logoImg.width);
  } else {
    doc.setFontSize(16);
    doc.setFont("Roboto", "bold");
    doc.text("František Malina - ElektroKit", 14, 20);
  }

  doc.setFontSize(15);
  doc.setFont("Roboto", "bold");
  doc.text(`FAKTURA č. ${invoiceNumber}`, 196, 20, { align: "right" });

  const topY = 30;
  doc.setLineWidth(0.2);
  doc.setDrawColor(0, 0, 0);

  // 1. BOX: Dodavatel
  doc.rect(14, topY, 91, 55);
  doc.setFontSize(9);
  doc.setFont("Roboto", "bold");
  doc.text("Dodavatel:", 16, topY + 5);
  
  doc.setFontSize(11);
  doc.text("František Malina", 16, topY + 12);
  doc.setFontSize(9);
  doc.setFont("Roboto", "normal");
  doc.text("L. Želiny 502/5", 16, topY + 17);
  doc.text("Čáslav - Nové Město, 286 01", 16, topY + 22);
  doc.text("telefon: +420 739 123 456", 16, topY + 27); 
  doc.text("e-mail: elektrokit@seznam.cz", 16, topY + 32);
  doc.text("IČO: 29547563", 16, topY + 37);
  doc.text("Neplátce DPH", 16, topY + 42);
  
  doc.setLineWidth(0.5);
  doc.line(14, topY + 46, 105, topY + 46);
  doc.setLineWidth(0.2);
  doc.setFontSize(10);
  doc.setFont("Roboto", "bold");
  doc.text("Číslo účtu: 111341596 / 0100", 16, topY + 52); 

  // 2. BOX: Odběratel
  doc.rect(105, topY, 91, 55);
  doc.setFontSize(9);
  doc.setFont("Roboto", "normal");
  doc.text("Variabilní symbol:", 107, topY + 5);
  doc.setFont("Roboto", "bold");
  doc.text(invoiceNumber, 194, topY + 5, { align: "right" });
  
  doc.setFont("Roboto", "normal");
  doc.text("Konstantní symbol:", 107, topY + 10);
  doc.text("0308", 194, topY + 10, { align: "right" });

  doc.line(105, topY + 14, 196, topY + 14);
  
  doc.setFont("Roboto", "bold");
  doc.text("Odběratel:", 107, topY + 19);
  doc.setFontSize(11);
  doc.text(customerName, 107, topY + 28);
  doc.setFontSize(10);
  doc.setFont("Roboto", "normal");
  doc.text(address, 107, topY + 33);
  doc.text(`${zip} ${city}`, 107, topY + 38);

  // 3. BOX: Datumy a Platba
  const midY = topY + 55; 
  doc.rect(14, midY, 182, 20); 
  doc.line(105, midY, 105, midY + 20); 

  doc.line(14, midY + 6.6, 105, midY + 6.6);
  doc.line(14, midY + 13.3, 105, midY + 13.3);
  
  doc.setFontSize(9);
  doc.text("Forma úhrady:", 16, midY + 5);
  doc.text(paymentName || "", 103, midY + 5, { align: "right" });
  
  doc.text("Datum vystavení:", 16, midY + 11.6);
  doc.text(formatDate(today), 103, midY + 11.6, { align: "right" });
  
  doc.text("Datum splatnosti:", 16, midY + 18.3);
  doc.setFont("Roboto", "bold");
  doc.text(formatDate(dueDate), 103, midY + 18.3, { align: "right" });

  doc.setFont("Roboto", "bold");
  doc.text(`Číslo objednávky: ${invoiceNumber}`, 107, midY + 5);

  // --- TABULKA ---
  const tableColumn = ["Označení položky", "Množství", "J. cena", "Sleva", "Celkem"];
  const tableRows = [];

  cart.forEach((item) => {
    const qty = item.quantity || 1;
    const name = item.type === "single" ? item.product.name : "Kompletní přestavbová sada";
    tableRows.push([name, `${qty} ks`, `${item.price.toLocaleString()}`, "0 %", `${(item.price * qty).toLocaleString()}`]);
  });

  const cartSubtotal = cart.reduce((sum, item) => sum + (item.price * (item.quantity || 1)), 0);
  const extrasTotal = finalTotal - cartSubtotal;
  
  if (extrasTotal > 0) {
    tableRows.push([`Doprava a platba (${shippingName})`, "1 ks", `${extrasTotal.toLocaleString()}`, "0 %", `${extrasTotal.toLocaleString()}`]);
  } else {
    tableRows.push([`Doprava (${shippingName})`, "1 ks", "0", "0 %", "0"]);
  }

  autoTable(doc, {
    startY: midY + 25,
    head: [tableColumn],
    body: tableRows,
    theme: "plain",
    headStyles: { fontStyle: "bold", textColor: 0, lineWidth: 0.2, lineColor: 0 },
    bodyStyles: { textColor: 0 },
    styles: { font: "Roboto", fontSize: 9 }, // ZDE MÍSTO HELVETICA POUŽITO ROBOTO
    columnStyles: {
      0: { cellWidth: 80 },
      1: { halign: "right" },
      2: { halign: "right" },
      3: { halign: "center" },
      4: { halign: "right" },
    }
  });

  // --- SOUČET K ÚHRADĚ ---
  const finalY = doc.lastAutoTable.finalY + 5;
  
  doc.setDrawColor(0,0,0);
  doc.setLineWidth(0.5);
  doc.line(14, finalY, 196, finalY); 
  
  doc.setFont("Roboto", "bold");
  doc.setFontSize(11);
  doc.text("CELKEM K ÚHRADĚ Kč", 16, finalY + 7);
  doc.text(`${finalTotal.toLocaleString()}`, 196, finalY + 7, { align: "right" });
  
  doc.line(14, finalY + 10, 196, finalY + 10); 
  
  // --- PODPIS ---
  doc.setFont("Roboto", "normal");
  doc.setFontSize(9);
  doc.text("Vystavil: František Malina", 110, finalY + 20);
  
  doc.setFontSize(8);
  doc.setTextColor(120, 120, 120);
  doc.text("Tento doklad byl vygenerován elektronicky", 110, finalY + 28);
  doc.text("a nevyžaduje razítko ani fyzický podpis.", 110, finalY + 32);

  // --- PATIČKA ---
  doc.setTextColor(150, 150, 150);
  doc.setFontSize(8);
  doc.text("Fyzická osoba zapsaná v živnostenském rejstříku vedeném u Městského úřadu Čáslav.", 14, 280);
  doc.text("Tento doklad slouží zároveň jako dodací list a potvrzení o záruce.", 14, 284);

  // --- ULOŽENÍ ---
  const safeName = customerName ? customerName.replace(/\s+/g, "_") : "Zakaznik";
  doc.save(`Faktura_${invoiceNumber}_${safeName}.pdf`);
};